

	import { Vue, Component } from "vue-property-decorator";
	import { Header } from "element-ui";
	// @Component({
	//   name: "qualityTestDetail",
	// })
	export default{
		
		data(){
			return{
				form:{},
				tableData:{},
				tasteData:{},
				authorData:{},
				shopData:{},
				commentList:[],
				url:'https://pics1.baidu.com/feed/4610b912c8fcc3ce3ba51b6cf9155683d53f20e0.jpeg',
			};
		},
		mounted() {
				
			let paramter = {
					productEvalId:this.$route.query.id,
			};
			this.$http.get("producteval/"+this.$route.query.id,{params:paramter}).then((res: any) =>{
				
				this.tableData = res.data.data;
				this.tasteData = res.data.data.tasteVo;
				this.authorData = res.data.data.authorVo;
			});
			
			this.getAssessList();
			
		},
		created(){
			
			console.log(this.$route.query);
		},
		methods: {
			
			getAssessList(){

				let pageNum = 1;
				let pageSize = 10;
				let productEvalId = this.$route.query.id;
				let assessParentId = 0;
				let paramter = {
					pageNum,
					pageSize,
					productEvalId,
					assessParentId
				};
				this.$http.get("producteval/assess/manage/list",{params:paramter}).then((res:any)=>{
					
					let code = res.data.code;
					if(code == 200) {
						this.commentList = res.data.data.data;
						this.commentList = this.commentList.filter(t => t.delTag == 0);
						this.commentList = this.commentList.map(item=>{
						   if(item.answerCount != 0) {
							   item.hasChildren = true;
						   }
						   return item;
						});
						
					}
				});
			},
			load(tree, treeNode, resolve) {
				
				let pageNum = 1;
				let pageSize = 10;
				let productEvalId = tree.productEvalId;
				let assessParentId = tree.id;
				let paramter = {
						pageNum,
						pageSize,
						productEvalId,
						assessParentId
					};
				this.$http.get("producteval/assess/manage/list",{params:paramter}).then((res:any)=>{

					let tempArray = res.data.data.data;	
					tempArray = tempArray.filter(t => t.delTag == 0);
					setTimeout(() => {
						resolve(tempArray);
					}, 1000)
				});
			},
			
			handleDeleteComment(index,row){
				
				this.deleteComment(row.id);
			},
			
			// 删除评论
			deleteComment(value){
				
				console.log(value);
				let commentId = value;
				let paramter = {
						commentId
					};
				this.$http.post("producteval/assess/manage/"+commentId,{params:paramter}).then((res:any)=>{
				
					let code = res.data.code;
					let msg = res.data.msg;
					if(code == 200) {
						
						window.location.reload();
						this.$message({
						    message: msg,
						    type: 'success'
						});
					}
				});
			}
			
		},
		
	}
